import {
  Container,
  Typography,
  Box,
  Stepper,
  Step,
  StepLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableBody,
  Chip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/common/Header";
import ApprovedAnimation from "../components/Lottie/ApprovedAnimation";
import { useLocation } from "react-router-dom";
import styles from "../Style/Modules/newApprovedLimit.module.css";
import "../Style/Theme/index.css";
import useSelector from "../store/selector";
import { constant, decryptData, multiDecryption } from "../utils/utils";
import { apis } from "../services/apiService";
import Backdrop from "../components/common/Backdrop";
import LoadingDots from "../components/Lottie/LoadingDots";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import dayjs from "dayjs";
import VerifiedIcon from "@mui/icons-material/Verified";
import "../Style/Theme/index.css";
import configData from "../Config";

export default function NewApprovedLimit() {
  const { setRecoilVal, getRecoilVal } = useSelector();
  const [stageData, setStageData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  let location = useLocation();
  const checkMobileNumber = async () => {
    let getMobileNumberfromRecoil = getRecoilVal(
      constant.atomsName.USER_DETAIL
    );
    let decryptedData = await multiDecryption(getMobileNumberfromRecoil);
    if (decryptedData?.mobileNum) {
      try {
        setLoading(true);
        // let resp = await apis.getApi(
        //   `https://axiomuat.adanicapital.in/uslApplicationAPI/api/ApplicationFlow/GetStageList?Mobile=${decryptedData?.mobileNum}`
        // );
        let resp = await apis.getApi(
          `${configData.API_URL}ApplicationFlow/GetStageList?Mobile=${decryptedData?.mobileNum}`
        );
        let result = await resp.json();
        if (resp?.status === 200) {
          let reverseData = [];
          setLoading(false);
          result?.data?.length > 0 &&
            result?.data?.map((val) => {
              reverseData?.unshift(val);
            });
          // setStageData(result?.data);
          setStageData(reverseData);
        }
      } catch (error) {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    checkMobileNumber();
  }, []);
  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={false} />
        <Box py={2} className={styles.newApprovedLimitBox} sx={{ mt: "15px" }}>
          <ApprovedAnimation
            style={{
              width: "180px",
              height: "200px !important",
              position: "relative",
            }}
          />
          <Box>
            <Typography
              variant="h1"
              sx={{
                textAlign: "center",
                color: "#1D1E24",
                mx: 1,
                // marginTop: "-310px",
                fontWeight: "Bold",
              }}
            >
              {t(`Congratulations! Your LOS journey is completed.`)}
            </Typography>
          </Box>
        </Box>
        <Box className={styles.stepperContainer}>
          <Stepper activeStep={stageData.length} orientation="vertical">
            {stageData.map((data) => (
              <Step key={data.stageId}>
                <StepLabel>
                  <Chip
                    sx={{ fontWeight: "bold" }}
                    // className="typo_Th typo_bg_Th"
                    // className="typo_Th typo_bg_Th"
                    label={`${data.name}`}
                  />
                  <p>{`${dayjs(data.con).format("h:mm A")} on  ${dayjs(
                    data.con
                  ).format("DD MMM YYYY")}`}</p>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
        {loading && (
          <Backdrop ax="center">
            <LoadingDots />
          </Backdrop>
        )}
      </Container>
    </>
  );
}
